import { Heading } from '@/components/catalyst-ui/heading'
import { Text } from '@/components/catalyst-ui/text'
import { Badge } from '@/components/catalyst-ui/badge'
import { Switch } from '@/components/catalyst-ui/switch'
import PaymentSummary from './PaymentSummary'
import { calculatePeriodPrice, calculatePrivacyPrice, calculateTotalPrice, getPerYearPrice } from '../utils/priceCalculations'

export default function ReviewAndPayStep({ formData, setFormData, domainPriceData, domain }) {
  const { period, whois_privacy } = formData
  const basePrice = domainPriceData?.price || 0
  const prices = domainPriceData?.prices || {}
  const selectedPeriodPrice = calculatePeriodPrice(period, basePrice, prices)
  const perYear = getPerYearPrice(selectedPeriodPrice, period)
  const privacyPrice = 3
  const privacyTotal = calculatePrivacyPrice(period, whois_privacy, privacyPrice)
  const total = calculateTotalPrice(selectedPeriodPrice, privacyTotal)

  const summaryItems = [
    {
      label: `${period} Year ($${perYear.toFixed(2)}/year):`,
      price: selectedPeriodPrice
    }
  ]

  if (whois_privacy) {
    summaryItems.push({
      label: 'Private Registration:',
      price: privacyTotal
    })
  }

  return (
    <div className="flex flex-col items-center gap-6">
      <div className="text-center">
        <Heading level={3} className="!text-3xl !font-semibold text-gray-900">{domain} will soon be yours</Heading>
        <Text className="mt-2 !text-[#A1A1AA] !font-medium">Complete domain purchase</Text>
      </div>

      {/* Auto-renewal section */}
      <div className="w-full max-w-md">
        <div className="flex justify-start mb-1">
          <Badge color="green" className="!text-xs !font-semibold !py-1 !px-1.5 !bg-[#D1FAE5] !text-[#047857]">Recommended</Badge>
        </div>
        <div className="rounded-lg">
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <Text className="!text-sm !font-medium !text-black">Enable Auto-Renewal</Text>
              <Text className="!text-sm !font-[400px] !text-[#71717A] mt-1">Automatically renew your domain before it expires.</Text>
            </div>
            <Switch
              checked={formData.auto_renew}
              onChange={(checked) => setFormData(prev => ({ ...prev, auto_renew: checked }))}
              className="data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2 ![--switch-bg:#5C33FF] ![--switch-bg-ring:#5C33FF] ![--switch:white] ![--switch-ring:#5C33FF] ![--switch-shadow:#5C33FF]/20"
            />
          </div>
        </div>
      </div>

      {/* Summary section */}
      <PaymentSummary
        items={summaryItems}
        total={total}
        showPerYear={true}
      />
    </div>
  )
}
